import { cn } from "tailwind-variants";
import UseSvg from "common/vue/components/UseSvg.react.vue";
import { useDtfStore } from "./store";
import "./StickerSampleBanner.scss";

export default function StickerSampleBanner({ className, ...restProps }) {
  const store = useDtfStore();

  function isGuest() {
    return store.isGuest;
  }

  return (
    <div
      {...restProps}
      className={cn(
        "sticker-sample-banner scope-acdf386d",
        isGuest() && "sticker-sample-banner--guest",
        className
      )}
    >
      <div className="sticker-sample-banner__text scope-acdf386d">
        <div className="sticker-sample-banner__headline scope-acdf386d">
          <strong className="scope-acdf386d">
            {" "}
            10 Custom Stickers for{" "}
            <span className="sticker-sample-banner__discounted-price scope-acdf386d">$8.00</span>
          </strong>
        </div>
        <div className="scope-acdf386d">
          <strong className="scope-acdf386d">Pre-set 9 square inches (3" by 3")</strong>
        </div>
      </div>
      <div className="sticker-sample-banner__shipping scope-acdf386d">
        <UseSvg
          className="sticker-sample-banner__shipping-icon scope-acdf386d"
          icon="free-shipping-truck"
          width="60"
          height="60"
          data-testid="sticker-sample-banner-shipping-icon"
        />
        <div className="sticker-sample-banner__shipping-text scope-acdf386d">
          <strong className="scope-acdf386d">
            FREE SHIPPING
            <br className="scope-acdf386d" />
            ON YOUR 1ST ORDER!
          </strong>
        </div>
      </div>
    </div>
  );
}
